import React, { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Questionnaire } from "../Questionnarie/Questionnaire";
import { fetchSectionPreview } from "./preview-api";
import { LegacyStyledQuestion } from "./LegacyStyledQuestion";

// Section preview using the legacy <Questionnaire/> wrapper — gives the
// same BUNDL navbar, cloud hero, decorative imagery, action buttons and
// stepper that /questionnaire/N renders. Content (questions) is dynamic
// and read from the admin-preview API. Click handlers are stubbed since
// there's nothing to save or navigate to in preview context.
export default function AdminSectionPreview() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [lang, setLang] = useState(params.get("lang") === "ar" ? "ar" : "en");

  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    if (!id) return;
    fetchSectionPreview(id)
      .then((res) => setData(res))
      .catch(() => setError("Could not load section preview."));
  }, [id]);

  const sec = data?.section;
  const questions = useMemo(() => sec?.questions || [], [sec]);

  if (error) return <div style={{ padding: 40, textAlign: "center" }}>{error}</div>;
  if (!data) return <div style={{ padding: 40, textAlign: "center" }}>Loading preview…</div>;

  const bgTitle = (lang === "ar" && sec.title_arabic) ? sec.title_arabic : sec.title_english;
  // Stepper / decorative imagery key off pageNo. Use the section's sort_order
  // (1-7) when available; default to 1 so the first-page treatment kicks in.
  const pageNo = sec?.sort_order && sec.sort_order >= 1 && sec.sort_order <= 7 ? sec.sort_order : 1;

  return (
    <Questionnaire
      bgTitle={bgTitle}
      pageNo={pageNo}
      Qlang={lang}
      setQLang={setLang}
      orderId={null}
      onBackClick={() => {}}
      onNextClick={() => {}}
      onSaveLaterClick={() => {}}
      storeAnswers={[]}
      formData={{}}
      setFormData={() => {}}
      questions={
        <>
          {questions.length === 0 ? (
            <div style={{ padding: 40, textAlign: "center" }}>
              {lang === "ar"
                ? "لا توجد أسئلة في هذه الصفحة بعد."
                : "No questions are attached to this section yet."}
            </div>
          ) : (
            questions.map((q, idx) => (
              <LegacyStyledQuestion
                key={q.id}
                question={q}
                index={idx}
                value={answers[q.id]}
                onChange={(v) => setAnswers((p) => ({ ...p, [q.id]: v }))}
                lang={lang}
              />
            ))
          )}
        </>
      }
    />
  );
}
